// custom typefaces
require("typeface-montserrat")
require("typeface-merriweather")
// normalize CSS across browsers
require("./src/normalize.css")
// custom CSS styles
require("./src/style.css")

// Highlighting for code blocks
require("prismjs/themes/prism.css")

const React = require("react")
const Auth0Wrapper = require("./src/auth/Auth0Wrapper").default
const { SiteMetadataProvider } = require("./src/context/SiteMetadataContext")
const StaticQueryErrorBoundary = require("./src/components/StaticQueryErrorBoundary").default

// Client: use injected script so we don't depend on StaticQuery (avoids stale-query 404 after deploy)
const getSiteMetadata = () => {
  if (typeof window !== "undefined" && window.__GATSBY_SITE_METADATA__) {
    return window.__GATSBY_SITE_METADATA__
  }
  return {
    controllerUrl: "https://backstage.infict.com",
    auth0Domain: "",
    auth0ClientId: "",
    auth0Audience: undefined,
  }
}

exports.wrapRootElement = ({ element }) => {
  return React.createElement(
    StaticQueryErrorBoundary,
    null,
    React.createElement(
      SiteMetadataProvider,
      { value: getSiteMetadata() },
      React.createElement(Auth0Wrapper, null, element)
    )
  )
}
